import { createContext } from 'react';

const TableContext = createContext<Record<number, React.ReactElement>>({});

export default TableContext;
